import { FormsCheckBox, Spinner } from '@platform/components';
import { Control } from 'react-hook-form';
import { GreenCircleCheckmark } from '../../../../svg/GreenCircleCheckmark';
import { UpdateDiscoveryCallFormData } from './types';

type MatchDeclinedContentProps = {
  control: Control<UpdateDiscoveryCallFormData>;
  isSaving: boolean;
};

export const MatchDeclinedContent = (props: MatchDeclinedContentProps) => {
  return (
    <div className='flex flex-col gap-6 text-center items-center justify-center md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          <GreenCircleCheckmark size={150} />
          <div className='text-lg flex flex-col gap-4'>
            <div className='font-semibold'>Thanks for letting us know!</div>
            <div>
              Not every connection is the right fit, and that's okay. If you'd like, our team can reach
              out with recommendations.
            </div>
          </div>
          <div className='flex justify-center'>
            <FormsCheckBox control={props.control} name='requestedMatchingSupport' size='md'>
              Yes, I'd like recommendations from the MovingWorlds team
            </FormsCheckBox>
          </div>
        </>
      }
    </div>
  );
};
